import {
    CcRequirementLifecyclePhase,
    CcRequirementLifecyclePhaseCreate,
} from "server/models"
import { GET, POST, DELETE } from "client/store/utils"

export const LoadCcRequirementLifecyclePhases = (requirementId: number) => (
    GET(`/ccRequirementLifecyclePhase/requirementId/${requirementId}`)
    .then((lifecyclePhases: CcRequirementLifecyclePhase[]) => lifecyclePhases)
)

export const SaveCcRequirementLifecyclePhases = (
    data: CcRequirementLifecyclePhaseCreate[],
) => (
    POST(
        "/ccRequirementLifecyclePhase/save",
        JSON.stringify(data),
    )
)

export const DeleteCcRequirementLifecyclePhases = ( // delete all associated rows by requirementId or phaseId
    requirementId: number,
    phaseId: number,
) => (
    DELETE(`/ccRequirementLifecyclePhase/delete/${requirementId}/${phaseId}`)
    .then((removedRows: number) => removedRows)
)
